import axios from "axios";
import { labelDate } from "@/components/tasks/taskHelpers.js";

const state = {
	tags: [],
	lists: [],
	loading: true,
	tasks: [],
	currentPage: 1,
	totalPages: 0,
	order: "desc",
	sortBy: "id",
	filterPeriod: "",
	view: "",

	deletedCount: 0,
	allTasksCount: [0, 0, 0, 0],
	completedTasksCount: 0,
	commisionedTasks: 0,
	recievedTasks: 0,
};

const getters = {
	tags: (state) => {
		return state.tags;
	},
	lists: (state) => {
		return state.lists;
	},
	loading: (state) => {
		return state.loading;
	},
	tasks: (state) => {
		return state.tasks;
	},
	currentPage: (state) => {
		return state.currentPage;
	},
	totalPages: (state) => {
		return state.totalPages;
	},
	order: (state) => {
		return state.order;
	},
	sortBy: (state) => {
		return state.sortBy;
	},
	allTasksCount: (state) => {
		return state.allTasksCount;
	},
	commisionedTasks: (state) => {
		return state.commisionedTasks;
	},
	recievedTasks: (state) => {
		return state.recievedTasks;
	},
	view: (state) => {
		return state.view;
	},
};

const mutations = {
	setTags(state, payload) {
		state.tags = payload;
	},
	addTag(state, payload) {
		state.tags.push(payload);
	},
	setLoading(state, payload) {
		state.loading = payload;
	},
	removeTag(state, payload) {
		const tagIndex = state.tags.findIndex((tag) => tag.id === payload);
		state.tags.splice(tagIndex, 1);
	},
	editTagName(state, payload) {
		const tagIndex = state.tags.findIndex((tag) => tag.id === payload.id);
		state.tags[tagIndex].name = payload.name;
	},
	setLists(state, payload) {
		state.lists = payload;
	},
	addList(state, payload) {
		state.lists.push(payload);
	},
	removeList(state, payload) {
		const listIndex = state.lists.findIndex((list) => list.id === payload);
		state.lists.splice(listIndex, 1);
	},
	editListName(state, payload) {
		const listIndex = state.lists.findIndex(
			(list) => list.id === payload.id
		);
		state.lists[listIndex].name = payload.name;
	},
	setTasks(state, payload) {
		state.tasks = payload;
	},
	addTask(state, payload) {
		state.tasks.unshift(payload);

		if (!payload.creator_user_id && payload.deadline) {
			const termTags = labelDate(payload.deadline);
			if (termTags.find((item) => item === "today")) {
				state.allTasksCount[1]++;
			}
			if (termTags.find((item) => item === "tomorrow")) {
				state.allTasksCount[2]++;
			}
			if (termTags.find((item) => item === "thisWeek")) {
				state.allTasksCount[3]++;
			}
		}

		if (payload.task_list_id) {
			const listInx = state.lists.findIndex(
				(list) => list.id === payload.task_list_id
			);
			state.lists[listInx].total_tasks++;
			state.lists = Object.assign([], state.lists);
		}

		if (payload.taggables) {
			payload.taggables.forEach((tag) => {
				const tagInx = state.tags.findIndex((t) => t.id === tag.tag.id);
				tagInx && state.tags[tagInx].unfinished_tasks_count
					? state.tags[tagInx].unfinished_tasks_count++
					: (state.tags[tagInx].unfinished_tasks_count = 1);
			});
			state.tags = Object.assign([], state.tags);
		}

		state.allTasksCount[0]++;
		state.allTasksCount = Object.assign([], state.allTasksCount);
	},
	editTask(state, payload) {
		const index = state.tasks.findIndex((task) => task.id === payload.id);

		if (state.tasks[index].deadline) {
			const termTags = labelDate(state.tasks[index].deadline);
			if (termTags.find((item) => item === "today")) {
				state.allTasksCount[1]--;
			}
			if (termTags.find((item) => item === "tomorrow")) {
				state.allTasksCount[2]--;
			}
			if (termTags.find((item) => item === "thisWeek")) {
				state.allTasksCount[3]--;
			}
		}

		if (!payload.creator_user_id && payload.deadline) {
			const termTags = labelDate(payload.deadline);

			if (termTags.find((item) => item === "today")) {
				state.allTasksCount[1]++;
			}
			if (termTags.find((item) => item === "tomorrow")) {
				state.allTasksCount[2]++;
			}
			if (termTags.find((item) => item === "thisWeek")) {
				state.allTasksCount[3]++;
			}
		}

		if (state.tasks[index].task_list_id) {
			const listInx = state.lists.findIndex(
				(list) => list.id === state.tasks[index].task_list_id
			);
			listInx &&
				state.lists[listInx].total_tasks &&
				state.lists[listInx].total_tasks--;
		}

		if (payload.task_list_id && !payload.creator_user_id) {
			const listInx = state.lists.findIndex(
				(list) => list.id === payload.task_list_id
			);
			state.lists[listInx].total_tasks++;
			state.lists = Object.assign([], state.lists);
		}

		if (state.tasks[index].taggables && !payload.creator_user_id) {
			state.tasks[index].taggables.forEach((tag) => {
				const tagInx = state.tags.findIndex((t) => t.id === tag.tag.id);
				tagInx && state.tags[tagInx].unfinished_tasks_count--;
			});
			state.tags = Object.assign([], state.tags);
		}

		if (payload.taggables) {
			payload.taggables.forEach((tag) => {
				const tagInx = state.tags.findIndex((t) => t.id === tag.tag.id);
				tagInx && state.tags[tagInx].unfinished_tasks_count
					? state.tags[tagInx].unfinished_tasks_count++
					: (state.tags[tagInx].unfinished_tasks_count = 1);
			});
			state.tags = Object.assign([], state.tags);
		}

		state.tasks[index] = payload;
		state.tasks = Object.assign([], state.tasks);
		state.allTasksCount = Object.assign([], state.allTasksCount);
	},
	deleteTask(state, payload) {
		const index = state.tasks.findIndex((task) => task.id === payload);
		state.tasks.splice(index, 1);
	},
	deleteTasks(state, payload) {
		payload.forEach((id) => {
			const index = state.tasks.findIndex((task) => task.id === id);
			state.tasks.splice(index, 1);
		});
	},
	setCurrentPage(state, payload) {
		state.currentPage = payload;
	},
	setTotalPages(state, payload) {
		state.totalPages = payload;
	},
	addTaskItem(state, payload) {
		const index = state.tasks.findIndex(
			(task) => task.id === payload.task_id
		);
		state.tasks[index].taskItems.push(payload);
	},
	editTaskItem(state, payload) {
		const taskIndex = state.tasks.findIndex(
			(task) => task.id === payload.task_id
		);
		const taskItemIndex = state.tasks[taskIndex].taskItems.findIndex(
			(taskItem) => taskItem.id === payload.id
		);

		state.tasks[taskIndex].taskItems[taskItemIndex] = payload;
	},
	setOrder(state, payload) {
		state.order = payload;
	},
	setSortBy(state, payload) {
		state.sortBy = payload;
	},
	setDeletedTasks(state, payload) {
		state.deletedTasks = payload.data.data;
		state.deletedCount = payload.data.meta.total;
	},
};

const actions = {
	async getTags({ commit }) {
		await axios
			.get("tags/tasks")
			.then((response) => {
				const tags = response.data.data;
				commit("setTags", tags);
			})
			.catch((error) => {
				console.log("GET TAGS ERROR", error);
			});
	},

	async postTag({ commit }, payload) {
		let res = {};
		await axios
			.post("tags", payload)
			.then((response) => {
				res = {
					success: true,
					error: false,
					tag: response.data.data,
				};
				commit("addTag", response.data.data);
			})
			.catch((error) => {
				console.log("POST TAG ERROR", error);
				res = {
					success: false,
					error: error,
				};
			});
		return res;
	},

	async deleteTag({ commit }, payload) {
		await axios
			.delete(`tags/${payload}`)
			.then(() => {
				commit("removeTag", payload);
			})
			.catch((error) => {
				console.log("DELETE TAG ERROR", error);
			});
	},

	async updateTag({ commit }, payload) {
		await axios
			.patch(`tags/${payload.id}`, { name: payload.name })
			.then(() => {
				commit("editTagName", payload);
			})
			.catch((error) => {
				console.log("UPDATE TAG ERROR", error);
			});
	},

	async getLists({ commit }) {
		await axios
			.get("task-lists")
			.then((response) => {
				if (response.data && response.data.data) {
					commit("setLists", response.data.data);
				}
			})
			.catch((error) => {
				console.log("GET LISTS ERROR", error);
			});
	},

	async postList({ commit }, payload) {
		commit("setLoading", true);
		let res = {};
		await axios
			.post("task-lists", payload)
			.then((response) => {
				console.log(response);
				res = {
					success: true,
					error: false,
				};
				commit("addList", response.data.data);
				commit("setLoading", false);
			})
			.catch((error) => {
				console.log("POST LIST ERROR", error);
				res = {
					success: false,
					error: error,
				};
			});
		return res;
	},

	async deleteList({ commit }, payload) {
		await axios
			.delete(`task-lists/${payload}`)
			.then(() => {
				commit("removeList", payload);
			})
			.catch((error) => {
				console.log("DELETE LIST ERROR", error);
			});
	},

	async updateList({ commit }, payload) {
		await axios
			.patch(`task-lists/${payload.id}`, { name: payload.name })
			.then(() => {
				commit("editListName", payload);
			})
			.catch((error) => {
				console.log("UPDATE LIST ERROR", error);
			});
	},

	async getTasks({ commit, state }, payload) {
		commit("setLoading", true);

		if (state.view.name === "deleted") {
			await axios
				.get("tasks/trashed/data", {
					params: {
						page: payload.currentPage,
						sort_by: state.sortBy,
						order: state.order,
					},
				})
				.then((response) => {
					commit("setDeletedTasks", response);
					commit("setCurrentPage", response.data.meta.current_page);
					commit("setTotalPages", response.data.meta.last_page);
					commit("setTasks", response.data.data);
					console.log(response.data.data);
				})
				.catch((error) => {
					console.log("GET DELETED TASKS ERROR", error);
				})
				.finally(() => {
					commit("setLoading", false);
				});
		} else if (state.view.name === "commissioned") {
			await axios
				.get("tasks-commissioned", {
					params: {
						page: payload.currentPage,
						sort_by: state.sortBy,
						order: state.order,
					},
				})
				.then((response) => {
					commit("setTasks", response.data.data);
					commit("setCurrentPage", response.data.meta.current_page);
					commit("setTotalPages", response.data.meta.last_page);
					console.log(response.data.data);
				})
				.catch((error) => {
					console.log("GET DELETED TASKS ERROR", error);
				})
				.finally(() => {
					commit("setLoading", false);
				});
		} else if (state.view.name === "received") {
			await axios
				.get("tasks", {
					params: {
						page: payload.currentPage,
						sort_by: state.sortBy,
						order: state.order,
						filter_status: "unfinished",
						filter_assigned: 1,
					},
				})
				.then((response) => {
					commit("setTasks", response.data.data);
					commit("setCurrentPage", response.data.meta.current_page);
					commit("setTotalPages", response.data.meta.last_page);
					console.log(response.data.data);
				})
				.catch((error) => {
					console.log("GET DELETED TASKS ERROR", error);
				})
				.finally(() => {
					commit("setLoading", false);
				});
		} else {
			let filter_period = "";
			let filter_status = "unfinished";
			let filter_task_list = "";
			let filter_tag = "";
			let total = "";

			if (
				state.view.name === "today" ||
				state.view.name === "tomorrow" ||
				state.view.name === "this_week"
			) {
				filter_period = state.view.name;
			} else if (state.view.name === "completed") {
				filter_status = "finished";
			} else if (state.view.name === "list") {
				filter_task_list = state.view.id;
			} else if (state.view.name === "tag") {
				filter_tag = state.view.id;
			}

			await axios
				.get("tasks", {
					params: {
						page: payload.currentPage,
						sort_by: state.sortBy,
						order: state.order,
						filter_period: filter_period,
						filter_status: filter_status,
						filter_task_list: filter_task_list,
						filter_tag: filter_tag,
					},
				})
				.then((response) => {
					commit("setTasks", response.data.data);
					commit("setCurrentPage", response.data.meta.current_page);
					commit("setTotalPages", response.data.meta.last_page);

					total = response.data.meta.total;
				})
				.catch((error) => {
					console.log("GET TASKS ERROR", error);
				})
				.finally(() => {
					commit("setLoading", false);
				});
			return total;
		}
	},

	async getDeletedTasks({ commit }, payload) {
		commit("setLoading", true);
		await axios
			.get("tasks/trashed/data", {
				params: {
					page: payload.currentPage,
				},
			})
			.then((response) => {
				commit("setDeletedTasks", response);
				commit("setCurrentPage", response.data.meta.current_page);
				commit("setTotalPages", response.data.meta.last_page);
				commit("setTasks", response.data.data);
				console.log(response.data.data);
			})
			.catch((error) => {
				console.log("GET DELETED TASKS ERROR", error);
			})
			.finally(() => {
				commit("setLoading", false);
			});
	},

	async postTask({ commit }, payload) {
		let res = {};
		await axios
			.post("tasks", payload)
			.then((response) => {
				res = {
					success: true,
					taskID: response.data.data.id,
					error: false,
				};

				commit("addTask", response.data.data);
			})
			.catch((error) => {
				console.log("POST TASKS ERROR", error);
				res = {
					success: false,
					error: error,
				};
			});
		return res;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
